import { observer } from 'mobx-react-lite';
import * as React from 'react';

import './bank-comparison.css';

import payhawkLogo from '../assets/payhawk-logo.svg';
import spendeskLogo from '../assets/spendesk.svg';
import { Bar } from '../components/bar/bar';
import { CardBank, IFeeComparison } from '../contracts';
import { Store } from '../stores/store';
import { formatAmount } from '../utils/amounts';

interface IProps {
    store: Store;
}

export const BankComparisonSection = observer<IProps>(({ store }) => {
    const renderComparison = React.useCallback((fee: IFeeComparison) => {
        switch (fee.type) {
            case CardBank.Payhawk:
                return (
                    <div key={fee.type} className='fee-wrapper'>
                        <div className='text'>
                            {formatAmount(store.estimatedPayhawkFees, store.bankChargeAmount.currency)}
                        </div>
                        <Bar volume={1} color='green' />
                        <div className='logo'>
                            <img src={payhawkLogo} alt='payhawk' />
                        </div>
                    </div>
                );
            case CardBank.Spendesk:
                return (
                    <div key={fee.type} className='fee-wrapper'>
                        <div className='text'>
                            {formatAmount(store.estimatedSpendDeskFees, store.bankChargeAmount.currency)}
                        </div>
                        <Bar volume={store.estimatedPayhawkVersusSpendesk} color='orange' />
                        <div className='logo'>
                            <a href='https://www.spendesk.com/' target='blank'><img src={spendeskLogo} alt='spendesk' /></a>
                        </div>
                    </div>
                );
            case CardBank.YourBank:
                return (
                    <div key={fee.type} className='fee-wrapper'>
                        <div className='text'>
                            {formatAmount(store.estimatedBankFees, store.bankChargeAmount.currency)}
                        </div>
                        <Bar volume={store.estimatedPayhawkVersusBankFees} color={store.estimatedPayhawkVersusBankFees > 1 ? 'red' : 'green'} />
                        <div className='text'>
                            YOUR CARD
                    </div>
                    </div>
                );
        }
    }, [store]);
    return (
        <div>
            <p className='big'>
                {store.estimatedPayhawkVersusBankFees > 1 ? (
                    <>
                        Your card is <em>{store.estimatedPayhawkVersusBankFees} times</em> more expensive than the best Visa Commercial cards.
                    </>
                ) : 'Your card is comparable to the best Visa Commercial cards.'}
                {' '}For this transaction you paid <em>{formatAmount(store.estimatedBankFees, store.bankChargeAmount.currency)}</em>.
            </p>
            <div className='bank-comparison'>
                {store.feeComparisons.map(renderComparison)}
            </div>
            <div className='btn-wrapper'>
                <button type='button' className='btn' onClick={store.goBack}>Back</button>
                <button type='button' className='btn btn-green' onClick={store.goToYearlyBudget}>Continue</button>
            </div>
        </div>
    );
});